export class ListDirectoryEdgesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<DirectoryEdgeRecord>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDirectoryEdgesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
